import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const saveFetchedCommonAreaAssets = (_,{ payload }) => {
    return payload;
}

const saveCommonAreaAssetDone = (commonAreaAssets, { payload }) => {
    return [ payload, ...commonAreaAssets]
}

const updateCommonAreaAssetDone = ( commonAreaAssets, { payload }) => {
    return commonAreaAssets.map( (data) => {
        if(data.id === payload.id){
            return payload
        }else{
            return data
        }
    })
}

const deleteCommonAreaAssetDone = ( commonAreaAssets, { payload }) => {
    return commonAreaAssets.filter( data => data.id!== payload )
}

const initialState = [];

export default createReducer(initialState,{
[TYPES.FETCH_COMMON_AREA_ASSETS_DONE] : saveFetchedCommonAreaAssets,
[TYPES.SAVE_COMMON_AREA_DONE]:saveCommonAreaAssetDone,
[TYPES.UPDATE_COMMON_AREA_DONE]:updateCommonAreaAssetDone,
[TYPES.DELETE_COMMON_AREA_DONE]:deleteCommonAreaAssetDone
})